import React, { useContext, useLayoutEffect } from 'react';
import { Container, getStateColors, Icon, TextAreaContainer, TextArea } from './TextArea.styled';
import { ComponentProps, IconPosition } from './TextArea.types';
import { ThemeContext } from '@emotion/core';

const TextAreaInput = React.forwardRef<HTMLTextAreaElement, ComponentProps>(
  ({ mode = 'primary', state, autoResize, beforeInput, leftIcon, rightIcon, ...props }, ref) => {
    const themeContext = useContext(ThemeContext);
    const stateColors = getStateColors();
    const stateColor = state && Object.keys(stateColors).includes(state) ? stateColors[state] : stateColors.default;

    const isAutoResize = props.id && autoResize;

    const resizeHandler = (textarea: HTMLElement, e: Event) => {
      if (!textarea) return;
      const target = e.target as HTMLTextAreaElement;
      target.style.height = 'inherit';
      target.style.height = `${textarea.scrollHeight}px`;
    };

    useLayoutEffect(() => {
      if (!isAutoResize) return;
      const textarea: HTMLElement = document.getElementById(props.id);
      textarea.style.height = `${textarea.scrollHeight}px`;
      textarea.addEventListener('input', resizeHandler.bind(null, textarea));
      return () => textarea.removeEventListener('input', resizeHandler.bind(null, textarea));
    }, []);

    return (
      <Container state={state} mode={mode} disabled={props.disabled} value={props.value}>
        {leftIcon !== undefined && (
          <Icon iconPosition={IconPosition.LEFT} mode={mode}>
            {leftIcon(stateColor)}
          </Icon>
        )}
        <TextAreaContainer>
          {beforeInput}
          <TextArea rows={1} ref={ref} mode={mode} autoResize={isAutoResize} {...props} />
        </TextAreaContainer>
        {rightIcon !== undefined && (
          <Icon iconPosition={IconPosition.RIGHT} mode={mode}>
            {rightIcon(stateColor)}
          </Icon>
        )}
      </Container>
    );
  },
);

export default TextAreaInput;
